/**
 * State used for address lookup.
 * @param AddressLookupService service used for the address lookup.
 * @param initialAddress initial address value.
 * @param onLookup callback of type Address[] => Unit to invoke with the lookup result.
 * @param onNoResult callback to invoke when no address was found.
 * @param onLookupFail callback to invoke when address lookup failed.
 */
define([], () => (AddressLookupService, {initialAddress, onLookup, onNoResult, onLookupFail}) => {
    let address = initialAddress;
    let loading = false;
    let haveError = false;

    return {
        get address() { return address; },
        set address(newAddress) {
            address = newAddress;
            haveError = false;
        },
        get loading() { return loading; },
        get hasError() { return haveError; },
        lookup() {
            if (loading) {
                return;
            }
            loading = true;
            AddressLookupService.autofillBasedOnAdddress('quoteandbind', address).then(
                addressInfo =>{
                    loading = false;
                    if (addressInfo && addressInfo.matches && addressInfo.matches.length > 0) {
                        haveError = false;
                        onLookup(addressInfo.matches);
                    } else {
                        haveError = true;
                        onNoResult();
                    }
                },
                () => {
                    loading = false;
                    haveError = true;
                    onLookupFail();
                }
            );
        }
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/tiles/address/models/LookupAddressState.js
 **/